import { NgModule } from '@angular/core';

import { CmpsTeamsCallCallDialogModule } from './call-dialog';
import { CmpsTeamsCallCallHudModule } from './call-hud';
import { CallStatusService, SocketService } from './core';

@NgModule({
    imports: [CmpsTeamsCallCallDialogModule, CmpsTeamsCallCallHudModule],
    providers: [CallStatusService, SocketService],
})
export class CmpsTeamsCallModule {}
